export default {
  errors: {
    internal: 'An unexpected error has occurred, please try again.',
    business: 'Please try another payment method.',
    threeDsTimeout: '3D Secure authentication took too long. Please try again.',
    threeDsScriptLoad: '3D Secure authentication could not be loaded. Please try again.',
    order: {
      emptyCustomerId: 'CustomerId was not received at order creation',
    },
  },
  loading: {
    default: 'Authenticating payment\nwith 3D Secure 2',
  },
};
